<template>
  <div id="app">

    <div class="content-header">
      <h1>用户列表</h1>
    </div>

    <div class="app-container">


      <el-table size="small" current-row-key="id" :data="dataList" stripe highlight-current-row>
        <el-table-column prop="id" align="center" label="id"></el-table-column>
        <el-table-column prop="fileName" label="文件名" align="center"></el-table-column>
        <el-table-column prop="originName" label="上传文件名" align="center"></el-table-column>
        <el-table-column prop="filePath" label="Url" align="center"></el-table-column>
        <el-table-column prop="fileSize" label="文件大小" align="center"></el-table-column>
        <el-table-column prop="checkCode" label="checkCode" align="center"></el-table-column>
        <el-table-column prop="createTime" label="创建时间" align="center"></el-table-column>
        <el-table-column prop="createUser" label="创建用户" align="center"></el-table-column>
      </el-table>


    </div>

  </div>

</template>

<script>
import axios from "@/axios";

export default {
  name: 'ApksInfo',
  data: function(){
    return {
      dataList: []//当前页要展示的列表数据
    }
  },

  //钩子函数，VUE对象初始化完成后自动执行
  mounted() {
    //调用查询全部数据的操作
    this.getAll();
  },

  methods: {
    getAll() {
      axios.get("/sys/file/info").then((res)=>{
        console.log(res.data);
        this.dataList = res.data.data;
      });

    }
  }
}

</script>
